// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2ujDf","checkboxCol":"Table_checkboxCol__3zg8A","emailCol":"Table_emailCol__2Dzcw","actionCol":"Table_actionCol__2TOpP"};